export default __webpack_public_path__ + "static/media/lisieux01.6c66aaf6.jpg";